import React from "react";

import { Stack, Typography } from "@mui/material";
import { CurrencyType } from "store/types";

interface Props {
  value: string;
  currency: CurrencyType;
}

export const TotalRow: React.FC<Props> = ({ value, currency }) => {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        alignItems: "center",
        p: "5px 26px",
        backgroundColor: "#edf1f9",
        borderRadius: "8px",
        gap: "10px"
      }}
    >
      <Typography sx={{ fontSize: "16px", color: "#0a3142", fontWeight: 500, width: 100 }}>Total</Typography>
      <Typography sx={{ fontSize: "15px", width: 115, textAlign: "left" }}>{value}</Typography>
      {currency && <Typography sx={{ fontSize: "15px", width: 64 }}>{currency}</Typography>}
    </Stack>
  );
};
